import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
import { useTranslation } from 'react-i18next';

export const FORM_OWNER_EDIT_ID = 'form-owner-edit';

export default function FormOwnerEdit({ owner, onSubmit }) {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
    });

    useEffect(() => {
        if (owner) {
            setFormData({
                first_name: owner.first_name ?? owner.firstname ?? '',
                last_name: owner.last_name ?? owner.lastname ?? '',
                email: owner.email ?? '',
            });
        }
    }, [owner]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.first_name.trim() || !formData.last_name.trim() || !formData.email.trim()) return;
        onSubmit({ ...formData });
    };

    return (
        <form
            id={FORM_OWNER_EDIT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-6 py-4 space-y-5"
        >
            <Field>
                <FieldLabel required>{t('subsidiary:prenom')}</FieldLabel>
                <Input
                    type="text"
                    placeholder={t('subsidiary:marie')}
                    value={formData.first_name}
                    onChange={(e) => handleChange('first_name', e.target.value)}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('subsidiary:nom2')}</FieldLabel>
                <Input
                    type="text"
                    placeholder="DUBOIS"
                    value={formData.last_name}
                    onChange={(e) => handleChange('last_name', e.target.value)}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('subsidiary:email')}</FieldLabel>
                <Input
                    type="email"
                    placeholder="marie.dubois@example.fr"
                    value={formData.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    required
                />
            </Field>
        </form>
    );
}
